import { Component, OnInit } from '@angular/core';
import {AlertController, NavController, NavParams} from "@ionic/angular";
import {RealTimeService} from "../realtime.service";
import {DataManagementService} from "../../data-management/data-management.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-prompt',
  templateUrl: './prompt.component.html',
  styleUrls: ['./prompt.component.scss'],
})
export class PromptComponent {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private realTimeService: RealTimeService,
    public dataManagementService: DataManagementService,
    private translate: TranslateService,
  ) {}

  ionViewDidLoad() {
  // console.log('ionViewDidLoad PromptPage');
  }

  async stop() {
    let alert = await this.alertCtrl.create({
      message: this.translate.instant('PROMPT.confirmation'),
      inputs: [
        {
          name: 'username',
          placeholder: this.translate.instant('PROMPT.usernamePlaceholder')
        },
        {
          name: 'password',
          placeholder: this.translate.instant('PROMPT.passwordPlaceholder'),
          type: 'password'
        }
      ],
      buttons: [
        {
          text: this.translate.instant('PROMPT.confirm'),
          role: 'confirmer',
          handler: data => {
            this.stopEngine(this.dataManagementService.selectedVehicule!.idDevice, data)
          }
        },
        {
          text: this.translate.instant('APP.CANCEL'),
          role: 'Annuler',
          handler: data => {}
        }
      ]
    });
    await alert.present();
  }

  async start() {
    let alert = await this.alertCtrl.create({
      message: this.translate.instant('PROMPT.confirmation'),
      inputs: [
        {
          name: 'username',
          placeholder: this.translate.instant('PROMPT.usernamePlaceholder')
        },
        {
          name: 'password',
          placeholder: this.translate.instant('PROMPT.passwordPlaceholder'),
          type: 'password'
        }
      ],
      buttons: [
        {
          text: this.translate.instant('PROMPT.confirm'),
          role: 'confirmer',
          handler: data => {
            this.startEngine(this.dataManagementService.selectedVehicule!.idDevice)
          }
        },
        {
          text: this.translate.instant('APP.CANCEL'),
          role: 'Annuler',
          handler: data => {}
        }
      ]
    });
    await alert.present();
  }

  startEngine(deviceId: any) {
    this.realTimeService.startEngine(deviceId).subscribe(() => {
      alert(this.translate.instant('PROMPT.startCommandSent'));
    });
  }

  stopEngine(deviceId: any, authData: any) {
    this.realTimeService.stopEngine(deviceId).subscribe(() => {
      alert(this.translate.instant('PROMPT.stopCommandSent'));
    });
  }
}
